export enum EnergySupplier {
    Eneco = 'eneco',
    Elegant = 'elegant',
    Engie = 'engie',
    EnergiePuntBe = 'energie.be',
    TotalEnergies = 'totalenergies',
}
